import { useTranslation } from 'hooks/useTranslation'
import Head from 'next/head'
import { Step2 } from '../../features/MealPlan/screens/Step2'
import Script from 'next/script'
export default function MealPlan() {
  const { t } = useTranslation()

  // prettier-ignore
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'HowTo',
    name: 'Meal Planning Step 2: Breed and Weight',
    description: "Enter your pet's breed, weight, body condition and activity level.",
    step: [
      {
        '@type': 'HowToStep',
        name: 'Breed and Weight',
        url: 'https://wefeedraw.com/meal-plan/step-2',
        itemListElement: [
          {
            '@type': 'HowToDirection',
            text: 'What breed is your dog?'
          },
          {
            '@type': 'HowToDirection',
            text: 'Would you consider your dog to be a puppy?'
          },
          {
            '@type': 'HowToDirection',
            text: 'How much does your dog weigh?'
          },
          {
            '@type': 'HowToDirection',
            text: "What's test's ideal adult weight?"
          },
          {
            '@type': 'HowToDirection',
            text: "How would you describe your dog's current body condition?"
          },
          {
            '@type': 'HowToDirection',
            text: 'Do you want your dog to gain weight?'
          },
          {
            '@type': 'HowToDirection',
            text: 'Do you want your dog to lose weight?'
          },
          {
            '@type': 'HowToDirection',
            text: "What's the activity level of your dog?"
          }
        ]
      }
    ]
  };

  const jsonLdString = JSON.stringify(schema)

  return (
    <div>
      <Head>
        <title>{t('meal-plan:step-2.page-title')}</title>
        <meta name="title" content={t('meal-plan:meta-title')} />
        <meta name="description" content={t('meal-plan:meta-description')} />
        <link rel="canonical" href="https://wefeedraw.com/meal-plan/step-2" />
      </Head>

      <main>
      <Script
        id="schema-script"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: jsonLdString }}
      />
        <Step2 />
      </main>
    </div>
  )
}
